
define('text!templates/modules/calendar/animated-session/animation/rename/edit/custom-name-edit-content.html',[],function () { return '<div class="panel-body custom-name-edit-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n\n    <div class="custom-name-edit-form"></div>\n\n</div>\n';});

